
/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
query SmsCountPendingQuery($customerId: ID!, $endDate: DateTime!, $startDate: DateTime!) {
  SmsCountPending(customerId: $customerId, endDate: $endDate, startDate: $startDate){
      count,
      _totalCount,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
